import { ColorsConfig } from "./colors-config.model";

export class AppConsts {
  readonly TRANS_EVENTS: string[] = ['transitionend', 'webkitTransitionEnd', 'oTransitionEnd'];
  readonly TRANS_PROPERTIES: string[] = ['transition', 'MozTransition', 'webkitTransition', 'WebkitTransition', 'OTransition'];
  readonly INLINE_STYLES: string = `
  .layout-menu-fixed .layout-navbar-full .layout-menu,
  .layout-menu-fixed-offcanvas .layout-navbar-full .layout-menu {
    top: {navbarHeight}px !important;
  }
  .layout-page {
    padding-top: {navbarHeight}px !important;
  }
  .content-wrapper {
    padding-bottom: {footerHeight}px !important;
  }`;
  readonly TRANSITION_EVENTS: string[] = ['transitionend', 'webkitTransitionEnd', 'oTransitionEnd'];
  readonly DELTA: number = 5;
  readonly colorsConfig: ColorsConfig = {
    colors: {
      primary: '#7367f0',
      secondary: '#a8aaae',
      success: '#28c76f',
      info: '#00cfe8',
      warning: '#ff9f43',
      danger: '#ea5455',
      dark: '#4b4b4b',
      black: '#000',
      white: '#fff',
      cardColor: '#fff',
      bodyBg: '#f8f7fa',
      bodyColor: '#6f6b7d',
      headingColor: '#5d596c',
      textMuted: '#a5a3ae',
      borderColor: '#dbdade'
    },
    colors_label: {
      primary: '#7367f029',
      secondary: '#a8aaae29',
      success: '#28c76f29',
      info: '#00cfe829',
      warning: '#ff9f4329',
      danger: '#ea545529',
      dark: '#4b4b4b29'
    },
    colors_dark: {
      cardColor: '#2f3349',
      bodyBg: '#25293c',
      bodyColor: '#b6bee3',
      headingColor: '#cfd3ec',
      textMuted: '#7983bb',
      borderColor: '#434968'
    },
    enableMenuLocalStorage: true // Enable menu state with local storage support
  };
}
